/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import { useTheme } from '../../../providers/theme';
import { useSMOrgComplianceDetailPage } from '../machines/pageContent';
import { Col, Row, Card, Button, Image } from 'react-bootstrap';
import { HeroSection, Header, BackArrowComp } from '../components';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { OrgComplianceDetailPageService } from '../services';
import { VApplication } from '../../../application';
import { useLocation } from 'react-router-dom';
const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.OrgComplianceDetailPageService'
  ) as OrgComplianceDetailPageService;
};
export const ContainerComm = (props: any) => {
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const theme = useTheme();
  const location = useLocation();
  const srv = getSrv();
  const { orgComplianceDetailPageState, orgComplianceDetailPageSend } =
    useSMOrgComplianceDetailPage({});
  console.log(`location`, location);
  const onRefresh = () => {};

  const onHeroButtonClick = (key: string) => {
    if (key === 'download') {
      document.getElementById('downloadPolicy')?.click();
    }
  };

  const _renderErrorModals = () => {
    // if (orgComplianceDetailPageState?.matches('RENDER_PAGE_ERROR')) {
    //   return (
    //     <NotificationModal
    //       showModal={true}
    //       {...(staticPageContentConfig?.error?.getTemplateList || {})}
    //       onAcknowledgement={onRefresh}
    //       onDeny={props?.goBack}
    //     />
    //   );
    // }
  };

  const _renderAnchorLink = () => {
    return (
      <a
        download={orgComplianceDetailPageState?.event?.data?.value?.title}
        href={orgComplianceDetailPageState?.event?.data?.value?.policyDocument}
        title="Download pdf document"
        id="downloadPolicy"
        style={{ display: 'none' }}
      />
    );
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <BackArrowComp />
          {/* <Header {...(staticPageContentConfig?.header || {})} /> */}
        </>
      );
    }
    return null;
  };

  const _renderPage = () => {
    if (location?.state) {
      let productDetail = srv?.formatPolicyDetail(location?.state);
      console.log(`product detail`, productDetail);
      return (
        <>
          <HeroSection
            {...(productDetail || {})}
            // {...(orgComplianceDetailPageState?.event?.data?.value || {})}
            onHeroButtonClick={onHeroButtonClick}
            carouselItems={productDetail?.carouselItems ?? []}
            // timelineDetails={
            //   orgComplianceDetailPageState?.event?.data?.value?.timelineDetails?? {listItems:[]}
            // }
            // buttons={orgComplianceDetailPageState?.event?.data?.value?.buttons}
          />
          {/* <TimelineComp
            {...(provisionaldetailPageState?.event?.data?.value || {})}
          /> */}
        </>
      );
    }
    // if (orgComplianceDetailPageState?.matches('RENDER_PAGE')) {
    //   return (
    //     <>
    //       <HeroSection
    //         {...(orgComplianceDetailPageState?.event?.data?.value || {})}
    //         onHeroButtonClick={onHeroButtonClick}
    //       />
    //       {/* <TimelineComp {...(orgComplianceDetailPageState?.event?.data?.value || {})}/> */}
    //     </>
    //   );
    // }
    // if (orgComplianceDetailPageState?.matches('GET_PAGE_CONTENT')) {
    //   return (
    //     <StateOSD
    //       {...(staticPageContentConfig?.loading?.retrieveCredentials || {})}
    //     />
    //   );
    // }
    return null;
  };
  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {_renderErrorModals()}
      {/* {_renderAnchorLink()} */}
    </>
  );
};
